import { render, staticRenderFns } from "./TableAlunos.vue?vue&type=template&id=68b72666&scoped=true"
import script from "./TableAlunos.vue?vue&type=script&lang=js"
export * from "./TableAlunos.vue?vue&type=script&lang=js"
import style0 from "./TableAlunos.vue?vue&type=style&index=0&id=68b72666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b72666",
  null
  
)

export default component.exports